export default class Animation{
    constructor({ element }){
        this.element = element;

        this.createObserver();
    }

    createObserver() {
        this.observer = new window.IntersectionObserver( (entries) => {
            entries.forEach((entry) => {
                if(entry.isIntersecting){ // If is in viewport
                    this.animateIn();
                } else {
                    this.animateOut();
                }
            })
        })

        this.observer.observe(this.element)
    }

    animateIn() {
        // That will be ovverride from animation/*.js
    }

    animateOut() {
        // That will be ovverride from animation/*.js
    }

    onResize() {
        // That will be ovverride from animation/*.js
    }
}